// extracted by mini-css-extract-plugin
module.exports = {"grid":"OutputQuestion_grid__2h3Iq","gridHeading":"OutputQuestion_gridHeading__2IrOX"};